import { render, staticRenderFns } from "./edit-membershipDemand.vue?vue&type=template&id=5f07554e&scoped=true&"
import script from "./edit-membershipDemand.vue?vue&type=script&lang=ts&"
export * from "./edit-membershipDemand.vue?vue&type=script&lang=ts&"
import style0 from "./edit-membershipDemand.vue?vue&type=style&index=0&id=5f07554e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f07554e",
  null
  
)

component.options.__file = "edit-membershipDemand.vue"
export default component.exports